import { createSlice } from "@reduxjs/toolkit";
import { NewEmployeeProps } from "../profile/types";

const initialState: Partial<NewEmployeeProps> = {
  employeeDetails: null,
};

const newEmpDtlReducer = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    setNewEmployeeDtl(state, action) {
      return {
        ...state,
        employeeDetails: action.payload,
      };
    },
  },
});

export default newEmpDtlReducer.reducer;

export const { setNewEmployeeDtl } = newEmpDtlReducer.actions;
